module.exports = __webpack_public_path__ + "static/img/strona_050.b34f2102.jpg";